module.exports = __webpack_public_path__ + "static/img/integrity-management1.f6b1e93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrity-management1.png
// module id = hR7f
// module chunks = 0